import React from "react"
import { Button } from "antd"
import {
	FilePdfOutlined,
	FileExcelOutlined,
	FileTextOutlined,
	FileOutlined,
	LinkOutlined,
} from "@ant-design/icons"
import strings from "utils/strings"

function fileIcon(filename: string) {
	const ext = filename.split(".").pop()?.toLowerCase()
	if (ext === "pdf")
		return <FilePdfOutlined style={{ fontSize: 22, color: "#E53E3E" }} />
	if (ext === "csv")
		return <FileTextOutlined style={{ fontSize: 22, color: "#38A169" }} />
	if (ext === "xls" || ext === "xlsx")
		return <FileExcelOutlined style={{ fontSize: 22, color: "#276749" }} />
	return <FileOutlined style={{ fontSize: 22, color: "#718096" }} />
}

export const FileAttachment: React.FC<{ url: string; filename: string }> = ({
	url,
	filename,
}) => (
	<div className="msg-file-card">
		<span className="msg-file-card__icon">{fileIcon(filename)}</span>
		<span className="msg-file-card__name" title={filename}>
			{filename}
		</span>
		<a href={url} target="_blank" rel="noopener noreferrer">
			<Button
				type="text"
				size="small"
				icon={<LinkOutlined />}
				className="msg-file-card__btn"
				title={strings.messaging.openFile}
			/>
		</a>
	</div>
)
